import { render, staticRenderFns } from "./OrderProductInfo.vue?vue&type=template&id=27e5afea&scoped=true&"
import script from "./OrderProductInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderProductInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrderProductInfo.vue?vue&type=style&index=0&id=27e5afea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e5afea",
  null
  
)

export default component.exports